import { render, staticRenderFns } from "./text-editor.vue?vue&type=template&id=43942416&scoped=true&"
import script from "./text-editor.vue?vue&type=script&lang=ts&"
export * from "./text-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43942416",
  null
  
)

export default component.exports